import { testimonials } from '@/mocks/data';

export default function TestimonialsSection() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-3">
            学员真实反馈
          </h2>
          <p className="text-foreground-600 text-base max-w-xl mx-auto">
            听听他们的学习故事，成人在线课程如何改变了他们的职业生涯
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.map((t) => (
            <div key={t.id} className="bg-background-50 rounded-2xl p-6 border border-background-200/60">
              <div className="flex items-center gap-1 mb-4">
                {Array.from({ length: t.rating }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-primary-500 text-sm"></i>
                ))}
              </div>
              <p className="text-foreground-700 text-sm leading-relaxed mb-5">{t.content}</p>
              <div className="flex items-center gap-3 pt-4 border-t border-background-100">
                <img
                  src={t.avatar}
                  alt={t.name}
                  className="w-10 h-10 rounded-full object-cover"
                />
                <div>
                  <div className="font-medium text-foreground-900 text-sm">{t.name}</div>
                  <div className="text-foreground-500 text-xs">{t.role} · {t.course}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}